<template>
	<div class="MainBox">
		<div class="BasicInfoHead">
      <p class="BasicInfoHeadLogo backImg" v-if="datas.logo" :style="{backgroundImage:'url('+datas.logo+')'}"></p>
      <p class="BasicInfoHeadLogo backImg" v-else></p>
      <p class="BasicInfoHeadName" v-if="datas.id_code_base">
        {{datas.name}}
        <i class="authenticated BlueState" v-if="datas.id_code_base.status_id == 100">已认证</i>
        <i class="authenticated RedState" v-else-if="datas.id_code_base.status_id == 0">待审核</i>
        <i class="authenticated RedState" v-else-if="datas.id_code_base.status_id == -1">审核失败</i>
        <i class="authenticated RedState" v-else-if="datas.id_code_base.status_id == -2">禁用</i>
        <i class="authenticated RedState" v-else-if="datas.id_code_base.status_id == -100">待完善资料</i>
      </p>
      <p class="BasicInfoHeadName" v-else>{{datas.name}}</p>
      <p class="BasicInfoHeadDate" v-if="datas.created_at">注册时间：{{datas.created_at}}</p>
      <p class="BasicInfoHeadExpire" v-if="datas.company_OID">OID：{{datas.company_OID}}</p>
      <p class="BasicInfoHeadExpire" v-else>商户编号 {{datas.rootid}}</p>
      <!-- <a class="BasicInfoHeadUpLogo NoSelect">保存设置</a> -->
      <a class="BasicInfoHeadUpLogo NoSelect" @click="HandleModel(true,1)">{{$t('b.BasicInfo.UploadLogo')}}</a>
    </div>

    <div class="BasicInfoNav">
      <template v-for="(item,index) in NavList">
        <a class="feedback" v-bind:key="index" v-if="item.isShow != false" v-text="item.name" :class="{NavActive:index == ix}" @click="ClickNav(index)"></a>
      </template>
    </div>

    <!-- 商户信息 -->
    <div class="BasicInfoBox BasicInfoOneBox" v-if="ix == 0">
      <div class="BasicInfoOneBoxLeft">
        <ul class="FormStyleOne" v-if="role == 10">
          <li class="FormStyleOneTitle">商户余额</li>
          <li>
            <p><input v-model="datas.money" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">商户名称</li>
          <li>
            <p><input v-model="datas.name" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">商户类型</li>
          <li>
            <p><input disabled="true" class="disabledInput" :value="datas.btype==1?'企业':'个人'" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="datas.trade">
          <li class="FormStyleOneTitle">所属行业</li>
          <li>
            <p><input v-model="datas.trade.trade_name" class="disabledInput" disabled="true" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">所属地区</li>
          <li>
            <p><input v-model="datas.address" disabled="true" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">企业地址</li>
          <li>
            <p><input v-model="datas.baddress" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="datas.btype == 1">
          <li class="FormStyleOneTitle">信用代码</li>
          <li>
            <p><input v-model="datas.organization_code" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="datas.btype == 2">
          <li class="FormStyleOneTitle">身份证号</li>
          <li>
            <p><input v-model="datas.idcard" class="disabledInput" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">经纬度</li>
          <li>
            <p><input v-model="datas.lon_lat" placeholder="请点击获取经销商经纬度" @focus="ClickMap(true)" @click="ClickMap(true)"  /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">联系人</li>
          <li>
            <p><input v-model="datas.linkman" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">联系电话</li>
          <li>
            <p><input v-model="datas.linkphone" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">关键词</li>
          <li>
            <p><input placeholder="多个关键词请用英文逗号分割" v-model="datas.keyword" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">外部链接</li>
          <li>
            <p><input placeholder="可输入外部链接" v-model="datas.link" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">商户简介</li>
          <li>
            <p>
              <textarea class="form-control"  v-model="datas.intro" ></textarea>
            </p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="role == 10">
          <li class="FormStyleOneTitle">兑换卡</li>
          <li>
            <p>
              <el-select v-model="datas.is_exchange" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">生码权限</li>
          <li>
            <p>
              <el-select v-model="datas.is_code" placeholder="请选择">
                <el-option
                    v-for="item in codeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="role == 10">
          <li class="FormStyleOneTitle">AI客服</li>
          <li>
            <p>
              <el-select v-model="datas.is_ai" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </p>
          </li>
        </ul>
        <ul class="FormStyleOne" v-if="role == 10">
          <li class="FormStyleOneTitle">校服绑定</li>
          <li>
            <p>
              <el-select v-model="datas.is_school_uniform" placeholder="请选择">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </p>
          </li>
        </ul>
        <div><a class="FormStyleOneBottomBtn btnRadius blueBackColor NoSelect" @click="ChangeBusinessInfo">{{$t('c.Common.Save')}}</a></div>
      </div>

      <div class="BasicInfoOneBoxRight" v-if="datas.btype == 1">
        <ul class="BasicInfoOneBoxImgs">
          <li>
            <p class="BasicInfoOneBoxImg backImg" v-if="datas.blicense" :style="{backgroundImage:'url('+datas.blicense+')'}"><a class="PreviewsImgBox" :href="datas.blicense" target="view_window"></a></p>
            <p class="BasicInfoOneBoxImg backImg" v-else></p>
            <p class="BasicInfoOneBoxTxt">营业执照</p>
          </li>
        </ul>

        <div style="margin-top: 10px;">
          <ul class="FormStyleTwo FormStyleTwoRow" v-for="(item,index) in datas.customize_data" v-bind:key="index">
            <li class="FormStyleTwo" style="padding:2px 0;">
              <input class="FormStyleTwoInputLeft" :placeholder="$t('b.ProductManage.HintFive')" v-model="item.key"/>
              <input class="FormStyleTwoInputRight" :placeholder="$t('b.ProductManage.HintSix')" v-model="item.value"/>
              <p class="btnArray FormStyleTwoImgBtnArrAbsolute">
                <a class="btnStyleTwo btnRadius blueBackColor" @click="HandleModel(true,2,index)">{{$t('c.Common.Image')}}</a>
                <a class="btnStyleTwo btnRadius redBackColor" @click="RemoveRow(index)">{{$t('c.Common.Delete')}}</a>
              </p>
            </li>
          </ul>
          <div class="btnStyleTwo greenBackColor btnRadius AddDefine" @click="addAttributeRow"><span class="icon iconfont iconicon-test20"></span>{{$t('b.ProductManage.AddLine')}}</div>
        </div>
      </div>
      <div class="BasicInfoOneBoxRight" v-if="datas.btype == 2">
        <ul class="BasicInfoOneBoxImgs">
          <li>
            <p class="BasicInfoOneBoxImg backImg" v-if="datas.idcard_img" :style="{backgroundImage:'url('+datas.idcard_img+')'}"><a class="PreviewsImgBox" :href="datas.idcard_img" target="view_window"></a></p>
            <p class="BasicInfoOneBoxImg backImg" v-else></p>
            <p class="BasicInfoOneBoxTxt">手持身份证照</p>
          </li>
        </ul>
      </div>

    </div>

    <!-- 企业权限 -->
    <div class="BasicInfoBox BasicInfoOneBox" v-else-if="ix == 1">
      <div class="BasicInfoOneBoxLeft">
        <template v-if="role == 10">
          <ul class="FormStyleOne">
            <li class="FormStyleOneTitle">企业分配</li>
            <li>
              <el-select v-model="datas.change_parent_rootid" filterable style="width: 320px;" clearable placeholder="请选择">
                <el-option
                    v-for="item in orgOptions"
                    :key="item.rootid"
                    :label="item.name"
                    :value="item.rootid"
                  >
                </el-option>
              </el-select>
            </li>
          </ul>
          <ul class="FormStyleOne">
            <li class="FormStyleOneTitle">OID编码</li>
            <li>
              <p><input v-model="datas.company_idcode" class="disabledInput" :placeholder="'1.2.156.3300.'+datas.rootid" /></p>
            </li>
          </ul>
          <ul class="FormStyleOne">
            <li class="FormStyleOneTitle">中文OID</li>
            <li>
              <p><input v-model="datas.org_cn_name" class="disabledInput" /></p>
            </li>
          </ul>
          <ul class="FormStyleOne">
            <li class="FormStyleOneTitle">英文OID码</li>
            <li>
              <p><input v-model="datas.org_en_name" class="disabledInput" /></p>
            </li>
          </ul>
        </template>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">生码域名</li>
          <li>
            <p><input v-model="datas.code_url" class="disabledInput" :placeholder="GetViewURL()" /></p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">生码量</li>
          <li>
            <p style="display: flex;">
              <el-radio-group v-model="radio1" @change="radioChangeValue" size="medium">
                <el-radio-button label="无限"></el-radio-button>
                <el-radio-button label="自定义"></el-radio-button>
              </el-radio-group>
              <el-input-number :controls="false" :disabled="this.radioControls" v-model="datas.user_package.code_limit" :min="-1" style="width: 150px;padding-left: 10px;" label="描述文字"></el-input-number>
            </p>
          </li>
        </ul>
        <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">授权时间</li>
          <li>
            <p>
              <input type="text" lay-verify="required" style="box-sizing:inherit" class="layui-input" id="publish_date" v-model="datas.user_package.due_date" placeholder="生码到期时间" autocomplete="off">
            </p>
          </li>
        </ul>
        <!-- <ul class="FormStyleOne">
          <li class="FormStyleOneTitle">促销时间</li>
          <li>
            <p><input v-model="datas.expire_date" class="disabledInput" placeholder="促销到期时间" /></p>
          </li>
        </ul> -->
        <div><a class="FormStyleOneBottomBtn btnRadius blueBackColor NoSelect" @click="ChangeBusinessInfo">{{$t('c.Common.Save')}}</a></div>
      </div>

    </div>

    <!-- 功能列表 -->
    <div class="BasicInfoBox BasicInfoOneBox" v-else-if="ix == 2">
      <table class="tableTwo">
        <thead>
          <tr>
            <th>功能</th>
            <th>描述</th>
            <th>收费</th>
            <th>到期时间</th>
            <th>状态</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle" v-if="ListDatas">
          <tr v-for="(item,index) in ListDatas" v-bind:key="index">
            <td><a v-text="item.name"></a></td>
            <td v-text="item.intro"></td>
            <td v-text="item.fee"></td>
            <td>
              <a v-if="item.due_date" v-text="item.due_date"></a>
              <a v-else>-</a>
            </td>
            <td>
              <a v-if="item.status == 0" class="grayColor">未开通</a>
              <a v-else-if="item.status == 1" class="grayColor">已过期</a>
              <a v-else-if="item.status == 2">已开通</a>
            </td>
          </tr>
        </tbody>
      </table>
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!ListDatas"></K-Transition>
    </div>

    <!-- 商品列表 -->
    <div class="BasicInfoBox BasicInfoOneBox" v-else>
      <viewer @inited="inited" ref="viewer">
      <table class="tableTwo">
        <thead>
          <tr>
            <th>名称</th>
            <th>图片</th>
            <th>规格</th>
            <th>库存</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle" v-if="ListDatas">
          <tr v-for="(item,index) in ListDatas" v-bind:key="index">
            <td><a v-text="item.name"></a></td>
            <td>
              <div class="tableImg backImg" :style="{backgroundImage: 'url(' + item.img + ')'}" v-if="item.img"><img v-if="item.img" class="tableImgShow" :src="item.img" @click="PreviewImgs"></div>
              <div class="tableImg backImg backImgNull" v-else></div>
            </td>
            <td v-text="item.stock_unit"></td>
            <td v-text="item.stock"></td>
            <td v-text="item.created_at"></td>
            <td>
              <a class="btnStyleTwo btnRadius greenBackColor" @click="GoToPage('ProductEdit?id='+item.production_id)" v-text="$t('c.Common.Edit')"></a>
            </td>
          </tr>
        </tbody>
      </table>
      </viewer>
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!ListDatas"></K-Transition>
    </div>

    <!-- 图片空间 -->
    <K-ImagePicker ref="imgPicker" :show-entry="false" @change="selectImg"></K-ImagePicker>

    <div class="mapbox" v-if="mapShow">
      <div class="mapShade" @click="ClickMap(false)"></div>
      <baidu-map :center="{lng:120.548984,lat:27.574843}" :zoom="14" @ready="handler" :scroll-wheel-zoom="true" class="MapMain" @click="getClickInfo">
        <bm-marker :position="{lng:120.548984, lat:27.574843}" :dragging="true">
          <bm-label content="深圳市中科链路科技有限公司" :labelStyle="{color:'red',fontSize:'13px'}" :offset="{width:-58,height:30}"/>
        </bm-marker>
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
      </baidu-map>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

	</div>
</template>

<script>
var self,form,layer,laydate;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Transition from '@/components/common/Transition.vue'
import ImagePicker from '@/components/common/ImagePicker.vue'
export default {
  name: 'BasicInfo',
  components: {
    'K-Paging': Paging,
    'K-Loading': Loading,
    'K-Transition': Transition,
    'K-Toast': Toast,
    'K-ImagePicker': ImagePicker
  },
  data () {
    return {
      ix:0,
      cix:0,
      page:1,
      role: 0,
      isHide: false,
      totalPages:0,
      loading:false,
      subHint:'数据加载中...',
      isLoding:true,
      mapShow:false,
      UploadType:null,
      options: [{
        value: '0',
        label: '禁用'
      }, {
        value: '1',
        label: '启用'
      }],
      codeOptions: [{
        value: '0',
        label: '启动'
      }, {
        value: '1',
        label: '禁用'
      }],
      Confirm:{
        state:false,
        txt:null
      },
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      NavList:[{
        name:"商户信息",
      },{
        name:"管理设置",
      },{
        name:"功能列表",
      },{
        name:"商品列表"
      }],
      datas:{
        logo:null,
        name:null,
        linkman:null,
        linkphone:null,
        keyword: null,
        link: null,
        intro:null,
        is_exchange: '0',
        is_code: '0',
        is_ai: '0',
        is_school_uniform: '0',
        organization_code:null,
        id_code_base:null,
        is_active: 0,
      },
      attribute:null,
      ListDatas:null,
      radio1: '自定义',
      radioControls: false,
      orgOptions: []
    }
  },
  created () {
    self = this;
    self.role = localStorage.getItem("wwmxt_Role");
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    this.isHide = ['1011'].includes(localStorage.getItem("wwmxt_Rootid")) || false;
    this.NavList[1].isShow = !this.isHide;
  },
  mounted () {
    layui.use(['form', 'layer', 'laydate'], function() {
      form = layui.form;
      layer = layui.layer;
      laydate = layui.laydate;

      if(self.$route.query.id){
        self.id = self.$route.query.id;
        self.GetData();
        self.queryOrgList();
      }else{
        javascript:history.back();
      }

    });
  },
  methods: {
    queryOrgList() {
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"org_list",{no_page:true})
          .then(function (response){
            self.orgOptions = response.data.meta;
            self.orgOptions.forEach( item => {
              item.rootid = parseInt(item.rootid);
            });
          }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    radioChangeValue() {
      if (this.radio1 === '无限') {
        this.radioControls = true;
        this.datas.user_package.code_limit = -1;
      } else {
        this.radioControls = false;
        this.datas.user_package.code_limit = 0;
      }
    },
    addAttributeRow () {
      if(!self.datas.customize_data){
        self.datas.customize_data = [];
      }
      self.datas.customize_data.push({key:"",value:""});
      self.$forceUpdate();
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    selectImg (img,name) {
      if(self.UploadType == 1){
        self.datas.logo = img;
      }else{
        self.datas.customize_data[self.cix].key = name;
        self.datas.customize_data[self.cix].value = img;
      }
    },
    ClickNav (ix) {
      self.ix = ix;
      if(ix == 1){
        self.$nextTick(() => {
          laydate.render({
            elem: '#publish_date',
            type: 'datetime',
            trigger: 'click',
            done: function(value, date, endDate) {
              self.datas.user_package.due_date = value;
            }
          });
        });
      }else if(ix == 2){
        self.GetFunctionList();
      }else if(ix == 3){
        self.GetProductList();
      }
    },
    GetData () {
      self.loading = true;
      axios.get(self.GetServerUrl(1)+"business/"+self.id)
      .then(function (response) {
          let datas = response.data.meta;
          datas.address = "";
          for(let item in datas.area){
            datas.address += datas.area[item].address_name+" "
          }
          if(!datas.user_package){
            datas.user_package = {due_date:null, code_limit: -1};
          }
          datas.is_exchange = datas.is_exchange || '0';
          datas.is_code = datas.is_code || '0';
          datas.is_school_uniform = datas.is_school_uniform || '0';
          datas.is_ai = datas.is_ai || '0';
          self.datas = datas;
          self.radio1 = datas.user_package.code_limit !== -1 ? '自定义' : '无限';
          self.radioControls = datas.user_package.code_limit === -1;
          self.loading = false;
          const orgid = datas.rootid?parseInt(datas.rootid.substring(0, 4)):'';
          if(!datas.change_parent_rootid && orgid && orgid != 1000){
            datas.change_parent_rootid = orgid;
          }
      }).catch(function (error){
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    GetOrderList () {
      self.ListDatas = null;
      self.isLoding = true;
      axios.post(self.GetServerUrl(1)+"order_list",{id:self.id,page:self.page})
      .then(function (response){
          self.ListDatas = response.data.meta.data;
          self.isLoding = false;

          //总页数
          self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    GetFunctionList () {
      self.ListDatas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"module/"+self.id,)
      .then(function (response){
          self.ListDatas = response.data.meta;
          self.isLoding = false;

          //总页数
          self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    GetProductList () {
      self.ListDatas = null;
      self.isLoding = true;
      let uid = localStorage.getItem("wwmxt_uid");
      axios.get(self.GetServerUrl(1)+"production_list/"+self.page+"/"+self.id,)
      .then(function (response){
          self.ListDatas = response.data.meta.data;
          self.isLoding = false;
          console.log(self.ListDatas)
          //总页数
          self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    RemoveRow (ix) {
      self.attribute.splice(ix,1);
    },
    ChangeBusinessInfo () {
      self.loading = true;

      //FormDatas格式提交
      let datas = {
        business_id:self.datas.rootid,
        name:self.datas.name,
        baddress: self.datas.baddress,
        logo:self.datas.logo,
        money: self.datas.money,
        linkphone:self.datas.linkphone,
        linkman:self.datas.linkman,
        keyword: self.datas.keyword,
        link: self.datas.link,
        intro:self.datas.intro,
        is_exchange: self.datas.is_exchange,
        is_code: self.datas.is_code,
        is_school_uniform: self.datas.is_school_uniform,
        is_ai: self.datas.is_ai,
        company_idcode:self.datas.company_idcode,
        code_url:self.datas.code_url,
        lon_lat:self.datas.lon_lat,
        due_date:self.datas.user_package.due_date,
        code_limit:self.datas.user_package.code_limit,
        app_id: self.datas.app_id,
        app_secret: self.datas.app_secret,
        org_cn_name: self.datas.org_cn_name,
        org_en_name: self.datas.org_en_name,
        enterprise_id: self.datas.enterprise_id,
        enterprise_user_id: self.datas.enterprise_user_id,
        customize_data:JSON.stringify(self.datas.customize_data),
        change_parent_rootid: self.datas.change_parent_rootid,
      };

      if(self.datas.id_code_base.status_id == -1 || self.datas.id_code_base.status_id == -100){
        datas.blicense = self.datas.blicense;
        datas.organization_code = self.datas.organization_code;
      }
      axios.patch(self.GetServerUrl(1)+"business",datas)
      .then(function (response){
        self.GetData();
        self.loading = false;
        self.ToastFun(0,response.data.message);  //弹窗提醒
      }).catch(function (error){
        let msg;
        if (error.response) {
          if(error.response.data.message){
            msg = error.response.data.message;
          }else{
            msg = error.response.statusText;
          }
        }else{
          msg = "请检查网络连接！";
        }
        self.loading = false;
        self.ToastFun(2,msg);  //弹窗提醒
      })
    },
    HandleModel (status,te,ix) {  //通过外部按钮触发图片空间弹窗
      self.UploadType = te;
      self.cix = ix;
      if (status && self.$refs.imgPicker) {
        self.$refs.imgPicker.openPicker();
      }
    },
    RemoveRow (ix) {
      self.datas.customize_data.splice(ix,1);
      self.$forceUpdate();
    },
    ClickMap (status) {
      this.loadBaiduMap(()=>{
        this.mapShow = status;
      })
    },
    handler ({BMap, map}) {

    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    },
    getClickInfo (e) {
      var point = new BMap.Point(e.point.lng, e.point.lat);
      var gc = new BMap.Geocoder();
      self.datas.lon_lat = e.point.lng+","+e.point.lat;
      self.mapShow = false;
    }
  }
}
</script>

<style scoped>
  .FormStyleOne input,.SelectStyle{
    width: 300px;
  }
  .FormStyleOneBottomBtn{
    padding:10px 18px;
    display: table;
    margin-top:25px;
    margin-left:90px;
    cursor: pointer;
  }
  .disabledInput{
    border:1px solid #DDD;
  }
  .tableTwo{
    margin-top:0;
  }
  .tableTwo > tbody > tr > td{
    color:#585A64;
  }
  .pass{
    top:4px;
  }
</style>
